import React from 'react';
import * as PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Helmet } from 'react-helmet';
import { Box, Hidden } from '@material-ui/core';
import Navbar from './NavBar';
import Drawer from './Drawer';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';
import { useAppConfiguration } from '../../shared/hook';

interface StyleProps {
  withUnlimitedCredits: boolean;
  showProductAssessment: boolean;
}

const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  root: {
    backgroundColor: colors.gainsboro,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: '100%',
    [theme.breakpoints.up('md')]: {
      paddingTop: 0,
      paddingLeft: 84,
    },
  },
  content: {
    paddingTop: 56 + 40,
    paddingBottom: 80,
    [theme.breakpoints.down('sm')]: {
      paddingTop: ({ withUnlimitedCredits, showProductAssessment }) => {
        if (showProductAssessment) {
          return 105;
        }

        return withUnlimitedCredits ? 90 : 149;
      },
    },
  },
}));

const AuthorizedLayout = (props: { title: any; children: any }) => {
  const { title, children } = props;
  const { withUnlimitedCredits, showProductAssessment } = useAppConfiguration();
  const classes = useStyles({ withUnlimitedCredits, showProductAssessment });

  return (
    <>
      <main className={classes.root}>
        {title && (
          <Helmet>
            <title>
              {title} | {process.env.REACT_APP_NAME}
            </title>
          </Helmet>
        )}
        <Hidden smDown>
          <Drawer />
        </Hidden>
        <Hidden mdUp>
          <Navbar />
        </Hidden>
        <Box className={classes.content}>{children}</Box>
      </main>
    </>
  );
};

AuthorizedLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

AuthorizedLayout.defaultProps = {
  title: '',
  children: null,
};

export default AuthorizedLayout;
